<template>
    <section
        id="prop-trustpilot"
        class="trustpilot"
        :class="{ hide: isBottom }"
    >
        <div
            v-if="isMobile"
            ref="trustbox"
            class="trustpilot-widget"
            data-businessunit-id="5bee914a9834d2000146adf4"
            data-font-family="Montserrat"
            data-locale="en-GB"
            data-style-height="112px"
            data-style-width="200px"
            data-template-id="53aa8807dec7e10d38f59f32"
            data-theme="light"
        ></div>
        <div
            v-else
            ref="trustbox"
            class="trustpilot-widget"
            data-businessunit-id="5bee914a9834d2000146adf4"
            data-font-family="Montserrat"
            data-locale="en-GB"
            data-style-height="120px"
            data-style-width="200px"
            data-template-id="53aa8807dec7e10d38f59f32"
            data-theme="light"
        ></div>
            <div v-if="isTipVisible" class="tip-overlay" @click="closetip"></div>
            <div 
                class="trustpilot-tip"
                :class="{ 'visible': isTipVisible, 'inVisible': !isTipVisible }"
                @click="toggletip"
            >
                <p>This is the Trustpilot review score of {{siteName}} and not the review score of the property.<br /> If you’d like to read more reviews of {{siteName}}, you can do so on our <span v-show="isTipVisible"><a :href="trustpilotUrl" target="_blank">Trustpilot page</a></span>.</p>
            </div>
    </section>
</template>

<script>
export default {
    data() {
        return {
            isBottom: false,
            isTipVisible: false,
            siteName: "Dog Friendly Cottages",
            trustpilotUrl : "https://uk.trustpilot.com/review/dogfriendlycottages.co.uk"
        };
    },
    methods: {
        addTrustBlock: function () {
            let script = document.createElement('script');
            script.src =
                '//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
            document.body.appendChild(script);
        },
        fadeAtTheBottom() {
            const winHeight = window.innerHeight;
            const bottom = document
                .getElementsByClassName('bottom')[1]
                .getBoundingClientRect();
            const foot = document
                .getElementById('foot')
                .getBoundingClientRect();
            const offset = -350;
            foot.top + offset < winHeight - bottom.height
                ? (this.isBottom = true)
                : (this.isBottom = false);

            // make notifications fade in/out on price_banner.vue    
            this.$emit('handleIsBottom', this.isBottom);
        },
        toggletip() {
            this.isTipVisible = !this.isTipVisible;
        },
        closetip()  {
            this.isTipVisible = false;
        }
    },
    props: {
        isMobile: Boolean,
    },
    mounted: function () {
        this.addTrustBlock();
        window.addEventListener('scroll', this.fadeAtTheBottom);
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.fadeAtTheBottom);
    },
};
</script>

<style scoped lang="scss">
@import 'app/assets/stylesheets/_vars.scss';

.trustpilot {
    margin: 1.25rem 0;
    padding: 0 1.25rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;

    @media #{$desktop} {
        padding-top: 0;
        transition: 0.3s ease-in-out;

        &.hide {
            opacity: 0;
            transition: 0.3s;
        }
    }
}

.trustpilot-tip {
        padding: 1rem;
        position: absolute;
        top: 3.5rem;
        left: 50%;
        border-radius: 0.25rem;
        font-size: 0.875rem;
        background: $col_white;
        width: 60%;
        transform: translate(-50%, -50%);
        border: 1px solid $col_bordergrey;
        &.inVisible {
            opacity: 0;
        }
        &.isTipVisible {
            opacity: 1;
        }

        @media #{desktop} {
          top: 3rem;
          width: 50%;
        }
}

.tip-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
